import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

class Modal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: this.props.visible,
        };

        this._hideModal = this._hideModal.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible) {
            this.setState({
                visible: this.props.visible,
            });
        }
    }

    _hideModal() {
        if (this.props.closeWithOverlay) this.props.onClose();
    }

    _renderOverlay() {
        const { visible } = this.state;

        let className = "z-20 fixed inset-0 bg-black transition duration-300";
        if (visible) {
            className += " opacity-60 pointer-events-auto";
        } else {
            className += " opacity-0 pointer-events-none";
        }

        return (
            <div className={className} onClick={this._hideModal}>
                <div className="absolute inset-0 bg-gray-500 opacity-75" />
            </div>
        );
    }

    _renderModal() {
        const {
            children,
            className,
            onClose,
            locale,
            fullHeight,
            customStyle,
            onCloseNoArrow,
            maxWidth,
        } = this.props;
        const { visible } = this.state;

        let wrapperStyle =
            "modal relative z-30 transition inline-block bg-white text-left shadow-xl transform transition-all w-full rounded xl:my-60 max-h-full hide-scroll";

        if (visible) {
            wrapperStyle +=
                " ease-out duration-300 opacity-100 translate-y-0 sm:scale-100";
        } else {
            wrapperStyle +=
                " ease-in duration-200 opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95";
        }

        wrapperStyle += " " + maxWidth;

        if (fullHeight) {
            wrapperStyle += " h-full";
        }

        let mainClassName = "relative " + className;

        return (
            <div
                className={wrapperStyle}
                style={customStyle}
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
            >
                <div className={mainClassName}>{children}</div>
            </div>
        );
    }

    render() {
        const { visible } = this.state;

        let className = "fixed z-40 inset-0";
        if (!visible) {
            className += " pointer-events-none";
        }

        return (
            <div className={className}>
                <Helmet>{visible && <body className="modal-open" />}</Helmet>
                <div className="flex items-end xl:items-center justify-center w-full h-full text-center">
                    {this._renderOverlay()}
                    {this._renderModal()}
                </div>
            </div>
        );
    }
}

Modal.defaultProps = {
    className: "",
    onClose: null,
    onCloseNoArrow: false,
    fullHeight: false,
    closeWithOverlay: false,
    customStyle: {},
    maxWidth: "xl:max-w-5xl",
};

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
